import { render, staticRenderFns } from "./ContactUsNew.vue?vue&type=template&id=64570b55&scoped=true"
import script from "./ContactUsNew.vue?vue&type=script&lang=js"
export * from "./ContactUsNew.vue?vue&type=script&lang=js"
import style0 from "./ContactUsNew.vue?vue&type=style&index=0&id=64570b55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64570b55",
  null
  
)

export default component.exports